export const arrivalTimeList = [
  {
    value: null,
    keyTranslate: 'arrival-time-i-dont-know'
  },
  {
    value: "00:00 - 01:00",
    keyTranslate: 'arrival-time-0000-0100'
  },
  {
    value: "01:00 - 02:00",
    keyTranslate: 'arrival-time-0100-0200'
  },
  {
    value: "02:00 - 03:00",
    keyTranslate: 'arrival-time-0200-0300'
  },
  {
    value: "03:00 - 04:00",
    keyTranslate: 'arrival-time-0300-0400'
  },
  {
    value: "04:00 - 05:00",
    keyTranslate: 'arrival-time-0400-0500'
  },
  {
    value: "05:00 - 06:00",
    keyTranslate: 'arrival-time-0500-0600'
  },
  {
    value: "06:00 - 07:00",
    keyTranslate: 'arrival-time-0600-0700'
  },
  {
    value: "07:00 - 08:00",
    keyTranslate: 'arrival-time-0700-0800'
  },
  {
    value: "08:00 - 09:00",
    keyTranslate: 'arrival-time-0800-0900'
  },
  {
    value: "09:00 - 10:00",
    keyTranslate: 'arrival-time-0900-1000'
  },
  {
    value: "10:00 - 11:00",
    keyTranslate: 'arrival-time-1000-1100'
  },
  {
    value: "11:00 - 12:00",
    keyTranslate: 'arrival-time-1100-1200'
  },
  {
    value: "12:00 - 13:00",
    keyTranslate: 'arrival-time-1200-1300'
  },
  {
    value: "13:00 - 14:00",
    keyTranslate: 'arrival-time-1300-1400'
  },
  {
    value: "14:00 - 15:00",
    keyTranslate: 'arrival-time-1400-1500'
  },
  {
    value: "15:00 - 16:00",
    keyTranslate: 'arrival-time-1500-1600'
  },
  {
    value: "16:00 - 17:00",
    keyTranslate: 'arrival-time-1600-1700'
  },
  {
    value: "17:00 - 18:00",
    keyTranslate: 'arrival-time-1700-1800'
  },
  {
    value: "18:00 - 19:00",
    keyTranslate: 'arrival-time-1800-1900'
  },
  {
    value: "19:00 - 20:00",
    keyTranslate: 'arrival-time-1900-2000'
  },
  {
    value: "20:00 - 21:00",
    keyTranslate: 'arrival-time-2000-2100'
  },
  {
    value: "21:00 - 22:00",
    keyTranslate: 'arrival-time-2100-2200'
  },
  {
    value: "22:00 - 23:00",
    keyTranslate: 'arrival-time-2200-2300'
  },
  {
    value: "23:00 - 24:00",
    keyTranslate: 'arrival-time-2300-2400'
  },
  {
    value: "00:00 - 01:00 (the next day)",
    keyTranslate: 'arrival-time-0000-0100-the-next-day'
  },
  {
    value: "01:00 - 02:00 (the next day)",
    keyTranslate: 'arrival-time-0100-0200-the-next-day'
  },
]



// WEBPACK FOOTER //
// ./src/app/utilities/arrival-time-list.ts